import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import Widget from "@ckeditor/ckeditor5-widget/src/widget";
import Command from "@ckeditor/ckeditor5-core/src/command";
export default class EmbedImage extends Plugin {
  static get requires() {
    return [Widget];
  }

  init() {
    // Enables the data-repository-item-id attribute to be added to an img tag
    this.editor.model.schema.extend("imageBlock", {
      allowAttributes: [
        "repository-item-id",
        "content-repository-attachable-id",
      ],
    });

    this.editor.model.schema.extend("imageInline", {
      allowAttributes: [
        "repository-item-id",
        "content-repository-attachable-id",
      ],
    });

    this.editor.conversion.for("upcast").attributeToAttribute({
      view: "data-repository-item-id",
      model: "repository-item-id",
    });

    this.editor.conversion.for("upcast").attributeToAttribute({
      view: "data-content-repository-attachable-id",
      model: "content-repository-attachable-id",
    });

    const updateAttribute = (
      viewWriter,
      attribute,
      newAttributeValue,
      element
    ) => {
      if (newAttributeValue !== null) {
        viewWriter.setAttribute(
          `data-${attribute}`,
          newAttributeValue,
          element
        );
      } else {
        viewWriter.removeAttribute(`data-${attribute}`, element);
      }
    };

    const updateImageBlockAttribute = (attribute) => {
      return (evt, data, conversionApi) => {
        if (!conversionApi.consumable.consume(data.item, evt.name)) {
          return;
        }

        const viewWriter = conversionApi.writer;
        const figure = conversionApi.mapper.toViewElement(data.item);
        const img = figure.getChild(0);

        updateAttribute(viewWriter, attribute, data.attributeNewValue, img);
        updateAttribute(viewWriter, attribute, data.attributeNewValue, figure);
      };
    };

    const updateImageInlineAttribute = (attribute) => {
      return (evt, data, conversionApi) => {
        if (!conversionApi.consumable.consume(data.item, evt.name)) {
          return;
        }

        const viewWriter = conversionApi.writer;
        const span = conversionApi.mapper.toViewElement(data.item);

        updateAttribute(viewWriter, attribute, data.attributeNewValue, span);
      };
    };

    this.editor.conversion.for("downcast").add((dispatcher) => {
      dispatcher.on(
        "attribute:repository-item-id:imageBlock",
        updateImageBlockAttribute("repository-item-id")
      );

      dispatcher.on(
        "attribute:content-repository-attachable-id:imageBlock",
        updateImageBlockAttribute("content-repository-attachable-id")
      );

      dispatcher.on(
        "attribute:repository-item-id:imageInline",
        updateImageInlineAttribute("repository-item-id")
      );

      dispatcher.on(
        "attribute:content-repository-attachable-id:imageInline",
        updateImageInlineAttribute("content-repository-attachable-id")
      );
    });

    this.editor.commands.add("embedImage", new EmbedImageCommand(this.editor));

    this.editor.on("addImage", (eventInfo, image) => {
      this.editor.execute("embedImage", {
        image,
      });
    });
  }
}

class EmbedImageCommand extends Command {
  execute({ image }) {
    this.editor.model.change(() => {
      const imageUtils = this.editor.plugins.get("ImageUtils");

      imageUtils.insertImage({
        src: image.url,
        "repository-item-id": image.repositoryItemId,
        "content-repository-attachable-id": image.contentRepositoryAttachableId,
      });
    });
  }
}
